//Nav scroll fixed header
const fixedHeader = 'wpk-nav-fixed';
const navScroll = document.querySelector('header#header-main');
const bodyTarget = document.querySelector('body');
const navOptions = { rootMargin: '0px', threshold: 0 };
let navObserver;

//If we have newer browsers
if (('IntersectionObserver' in window)) {

    //From customizer
    if (wpk_script_object.sticky_header === '1') {

        //Call function
        navObserver = new IntersectionObserver(onNavIntersection, navOptions);
        
        //Run function for nav selector
        navObserver.observe(navScroll);
    }
}

//function for running observer
function onNavIntersection(entries) {
    // Loop through the entries
    entries.forEach(entry => {
        //If we are in viewport
        if (entry.intersectionRatio > 0) {
            bodyTarget.classList.remove(fixedHeader);
        } else {
            bodyTarget.classList.add(fixedHeader);
        }
    });
}


//Mobile Nav Open
const navCheckBox = document.getElementById('header-nav-checkbox');
const navCheckClass = 'wpk-nav-open';
navCheckBox.addEventListener("change", bodyClassFunction, false);

//Function for body class to prevent scroll
function bodyClassFunction(){
  if(navCheckBox.checked){
    bodyTarget.classList.add(navCheckClass);
    //document.body.addEventListener('touchmove', handleTouchMove, {passive: false}); 
  } else {
    bodyTarget.classList.remove(navCheckClass);
    //document.body.removeEventListener('touchmove', handleTouchMove, {passive: false});
  }
}

//Stop scroll on touch sceens (for body scroll on hamburger menu)
function handleTouchMove(event) {
  //add prevent default on everything except menu
  if (!$(event.target).parents().hasClass('scrollable')) {
    event.preventDefault();
  }
}

//Stop page from scrolling when opening nav submenu
var navItem = document.querySelector('nav');
if (navItem) {
  navItem.addEventListener('click', function(event) {
    //IE11 fallback
    var matches = event.target.matches ? event.target.matches('a[href="#"]') : event.target.msMatchesSelector('a[href="#"]');
    if (matches) {
      event.preventDefault();
    }
  }, false);

}